import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Product from "../Product/Product";
import "./AllProduct.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import SubHeader from "../SubComp/SubHeader/SubHeader";

const AllProduct = () => {
  const hidetoggle = (props) => {
    let name = props;
    const shownPanel = document.querySelector("." + name);
    shownPanel.classList.toggle("dshow");
  };
  
  return (
    <>
      <Header />
      <SubHeader
        title="Original Paintings For Sale"
        text="Original Paintings For Sale"
        width="px-5"
      />
      <div className="allProduct bg_Dark">
        <div className="d-flex py-5">
          <div className="leftBar w20 px-5">
            <div className="sortingStart text-white">
              <h4 className="mt-0 mb-4">Category</h4>
              <form action="">
                <select
                  class="form-select  mb-4"
                  aria-label=".form-select-lg example"
                >
                  <option selected>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select>
                <div className="style">
                  <div className="heading_border cursor mb-4">
                    <div
                      className="d-flex justify-content-between align-items-center mb-2"
                      onClick={() => hidetoggle("id1")}
                    >
                      <h6>Style</h6>
                      <FontAwesomeIcon className="" icon={faMinus} />
                    </div>
                  </div>
                  <div className="style_child dnone id1">
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck1"
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Abstract
                      </label>
                    </div>
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck2"
                      />
                      <label class="form-check-label" for="exampleCheck2">
                        Fine Arts
                      </label>
                    </div>
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck3"
                      />
                      <label class="form-check-label" for="exampleCheck3">
                        Modern
                      </label>
                    </div>
                  </div>
                </div>
                <div className="style">
                  <div className="heading_border cursor mb-4">
                    <div
                      className="d-flex justify-content-between align-items-center mb-2"
                      onClick={() => hidetoggle("id2")}
                    >
                      <h6>Subject</h6>
                      <FontAwesomeIcon className="" icon={faMinus} />
                    </div>
                  </div>
                  <div className="style_child dnone id2">
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck1"
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Abstract
                      </label>
                    </div>
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck2"
                      />
                      <label class="form-check-label" for="exampleCheck2">
                        Fine Arts
                      </label>
                    </div>
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck3"
                      />
                      <label class="form-check-label" for="exampleCheck3">
                        Modern
                      </label>
                    </div>
                  </div>
                </div>
                <div className="style">
                  <div className="heading_border cursor mb-4">
                    <div
                      className="d-flex justify-content-between align-items-center mb-2"
                      onClick={() => hidetoggle("id3")}
                    >
                      <h6>Medium</h6>
                      <FontAwesomeIcon className="" icon={faMinus} />
                    </div>
                  </div>
                  <div className="style_child dnone id3">
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck1"
                      />
                      <label class="form-check-label" for="exampleCheck1">
                        Abstract
                      </label>
                    </div>
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck2"
                      />
                      <label class="form-check-label" for="exampleCheck2">
                        Fine Arts
                      </label>
                    </div>
                    <div class="mb-3 form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck3"
                      />
                      <label class="form-check-label" for="exampleCheck3">
                        Modern
                      </label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="rightBar w80">
            <Product />
          </div>
        </div>
      </div>
      <Footer displayNone="d-none" />
    </>
  );
};

export default AllProduct;
